import { AxisKey } from "./types";

// Ring order, innermost → outermost (spec: Focus, Energy, Pace, Direction).
export const RING_ORDER: AxisKey[] = ["focus", "energy", "pace", "direction"];

// Card / legend order.
export const CARD_ORDER: AxisKey[] = ["direction", "pace", "energy", "focus"];

export const AXIS_META: Record<
  AxisKey,
  {
    label: string;
    helper: string; // short legend / micro label
    ring: string; // stroke colour (decorative)
    text: string; // darker shade of the same hue, WCAG AA on white
  }
> = {
  direction: {
    label: "Direction",
    helper: "Where to aim",
    ring: "#6d4c92",
    text: "#6d4c92",
  },
  pace: {
    label: "Pace",
    helper: "How fast to move",
    ring: "#6aa6e8",
    text: "#2f6db5",
  },
  energy: {
    label: "Energy",
    helper: "How to use your energy",
    ring: "#c9a24b",
    text: "#8a6a12",
  },
  focus: {
    label: "Focus",
    helper: "What deserves attention",
    ring: "#6fbf9b",
    text: "#2f7a5a",
  },
};

// One plain line per state, so words like "transitional" are never a mystery.
export const STATE_HELP: Record<AxisKey, Record<string, string>> = {
  direction: {
    steady: "Your path is stable. No big turn needed right now.",
    transitional: "You are moving from one chapter of life to the next.",
    focused: "You know where you are heading and can aim straight at it.",
    expansive: "Doors are opening. It is a good time to explore and grow.",
  },
  pace: {
    slow: "A gentle phase. Rest and careful steps work best.",
    steady: "A balanced rhythm. Small, regular progress pays off.",
    fast: "Things move quickly. Say yes to what matters, protect your rest.",
    transitional: "Your speed is shifting. Expect it to feel uneven for a while.",
  },
  energy: {
    inner: "Your energy turns inward: thinking, resting, understanding yourself.",
    outer: "Your energy turns outward: meeting people, acting, getting things done.",
    balanced: "Inner and outer energy are in balance.",
  },
  focus: {
    self: "The most useful attention goes to you: health, habits, inner clarity.",
    work: "The most useful attention goes to work, goals and building something.",
    relationships: "The most useful attention goes to the people close to you.",
    mixed: "Several areas matter about equally. No single priority stands out.",
  },
};

export const WINDOW_LABEL: Record<string, string> = {
  now: "Now",
  next_3_months: "Next 3 months",
  long_arc: "Longer arc",
};

// What each personalization source means (shown in the compact panel).
export const SOURCE_EXPLANATION: Record<string, string> = {
  chart: "Your birth details, used as the base of every reading.",
  chartTiming: "Where you are in your current timing cycle today.",
  journeyNodes: "Key events you saved in your Journey.",
  emotionalPatterns: "Emotional patterns you confirmed in Astria memory.",
  userDecisions: "Recent decisions you saved in Astria memory.",
};

export const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
